import React from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { rgba } from "polished";

import {
  Box,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Chip as MuiChip,
  Typography as MuiTypography,
} from "@mui/material";
import { spacing } from "@mui/system";

const Card = styled(MuiCard)`
  position: relative;
  margin-bottom: ${(props) => props.theme.spacing(6)};
  border-radius: 24px;
  background: ${(props) =>
    props.bgcolor
      ? `linear-gradient(135deg, ${rgba(props.bgcolor, 0.12)} 0%, ${rgba(props.bgcolor, 0.02)} 100%)`
      : props.theme.palette.background.paper};
  color: ${(props) => props.theme.palette.text.primary};
  border: 1px solid ${(props) => (props.bgcolor ? rgba(props.bgcolor, 0.2) : "transparent")};
  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.1);
    border-color: ${(props) => (props.bgcolor ? props.bgcolor : "transparent")};
  }

  &:hover .stats-icon-wrapper {
    background: ${(props) => props.bgcolor || "transparent"};
    color: white;
    transform: scale(1.1) rotate(-5deg);
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 6px;
    height: 100%;
    background: ${(props) => props.bgcolor || "transparent"};
    opacity: 0.8;
  }
`;

const Typography = styled(MuiTypography)(spacing);

const CardContent = styled(MuiCardContent)`
  position: relative;
  padding: ${(props) => props.theme.spacing(6)};

  &:last-child {
    padding-bottom: ${(props) => props.theme.spacing(6)};
  }
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => (props.bgcolor ? rgba(props.bgcolor, 0.1) : "transparent")};
  color: ${(props) => props.bgcolor || "inherit"};
  font-size: 1.75rem;
  transition: all 0.3s ease;
`;

const Stats = ({ title, amount, chip, percentagetext, illustration, bgcolor, icon: Icon }) => {
  return (
    <Card illustration={illustration} bgcolor={bgcolor}>
      <CardContent>
        {Icon && (
          <IconWrapper bgcolor={bgcolor} className="stats-icon-wrapper">
            <Icon fontSize="inherit" />
          </IconWrapper>
        )}
        <Typography
          variant="h6"
          mb={2}
          sx={{
            fontWeight: 800,
            color: bgcolor ? rgba(bgcolor, 0.9) : "#1e293b",
            textTransform: "uppercase",
            letterSpacing: "0.1em",
            fontSize: "0.7rem",
            opacity: 0.8,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="h3"
          mb={0}
          sx={{
            fontWeight: 900,
            color: bgcolor || "text.primary",
            fontSize: "1.75rem",
          }}
        >
          <Box>{amount}</Box>
        </Typography>
      </CardContent>

      {!!illustration && <IllustrationImage src={illustration} alt="Illustration" />}
    </Card>
  );
};

export default Stats;
